export default __webpack_public_path__ + "static/dev-thumb-gallery-0542929b0bafe71039a05811fd76bebd.jpg";